import React, { useCallback, useRef } from 'react'
import DatePicker from 'react-datepicker'
import ReactDOM from 'react-dom'

import Moment from 'moment'

export default ({ name, id, value, onChange, timeFormat = 'h:mm aa', openToDate, portalId, ...props }) => {
  const datePickerRef = useRef(null)

  const popperContainer = useCallback(
    ({ children }) => {
      if (typeof document === 'undefined') return children
      const target = (portalId && document.getElementById(portalId)) || document.body
      return ReactDOM.createPortal(<div className="time-picker-portal">{children}</div>, target)
    },
    [portalId],
  )

  const handleOnChange = value => {
    const valueToUse = (() => {
      if (!value) return null
      return value
    })()

    onChange({
      target: {
        type: 'date-picker',
        name,
        value: valueToUse,
      },
    })
  }

  const valueAsDate = value ? Moment(value).toDate() : null

  return (
    <div className="input-group date-picker">
      <DatePicker
        {...props}
        ref={datePickerRef}
        id={id}
        className="form-control"
        selected={valueAsDate}
        value={null}
        onChange={handleOnChange}
        openToDate={openToDate}
        placeholderText="12:00 PM"
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeCaption="Time"
        dateFormat={timeFormat}
        popperContainer={popperContainer}
        onKeyDown={e => {
          if (e.key === 'Tab') {
            datePickerRef.current.setOpen(false)
          }
        }}
      />
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        className="input-group-append"
        onClick={() => {
          if (datePickerRef.current) {
            datePickerRef.current.setOpen(true)
            datePickerRef.current.input?.focus()
          }
        }}
        tabIndex={-1}
      >
        <span id="arrowIcon" className="fas fa-chevron-down input-group-text" tabIndex={-1}></span>
      </div>
    </div>
  )
}
